export default {
  title: 'Nuevo Activo',
  title_edit: 'Editando Activo',
  bulkRegister: 'Registro masivo',
  name: 'Nombre*',
  placeType: 'Tipo de local',
  place: 'Local',
  type: 'Tipo'
}
